import { combineReducers } from 'redux';
import login, * as fromLogin from './login';
import users, * as fromUsers from './users';
import addresses, * as fromAddresses from './addresses';
import subs, * as fromSubs from './subs';
import attSubs, * as fromAttSubs from './attSubs';
import tracfoneSubs, * as fromTracfoneSubs from './tracfoneSubs';
import simoSubs, * as fromSimoSubs from './simoSubs';
import leases, * as fromLeases from './leases';
import attLeases, * as fromAttLeases from './attLeases';
import tracfoneLeases, * as fromTracfoneLeases from './tracfoneLeases';
import simoLeases, * as fromSimoLeases from './simoLeases';
import credit, * as fromCredit from './credit';
import purchases, * as fromPurchases from './purchases';
import logs, * as fromLogs from './logs';
import serviceCodes, * as fromServiceCodes from './serviceCodes';
import tracfoneServiceCodes, * as fromTracfoneServiceCodes from './tracfoneServiceCodes';
import csa, * as fromCsa from './csa';
import customPlans, * as fromCustomPlans from './customPlans';
import plans, * as fromPlans from './plans';
import attPlans, * as fromAttPlans from './attPlans';
import tracfonePlans, * as fromTracfonePlans from './tracfonePlans';
import simoPlans, * as fromSimoPlans from './simoPlans';
import form, * as fromForm from './form';
import cycle, * as fromCycle from './cycle';
import filters, * as fromfilters from './filters';
import devices, * as fromDevices from './devices';
import insuranceContracts, * as fromInsuranceContracts from './insuranceContracts';
import insuranceDevices, * as fromInsuranceDevices from './insuranceDevices';
import insurancePlans, * as fromInsurancePlans from './insurancePlans';
import notes, * as fromNotes from './notes';
import payments, * as fromPayments from './payments';
import preactivations, * as fromPreactivations from './preactivations';
import voiceRecords, * as fromVoiceRecords from './voiceRecords';
import deviceContracts, * as fromDeviceContracts from './deviceContracts';
import rollingArrangements, * as fromRollingArrangements from './rollingArrangements';
import shippings, * as fromShippings from './shippings';
import orders, * as fromOrders from './orders';
import loginDevices, * as fromLoginDevices from './loginDevices';
import resellers from './resellers';
import allSubs, * as fromAllSubs from './allSubs';
import simoDiagnostics, * as fromSimoDiagnostics from './simoDiagnostics';
import simoTopUps, * as fromSimoTopUps from './simoTopUps';
import sqlReports, * as fromSqlReports from './sqlReports';
import sqlReportQueries, * as fromSqlReportQueries from './sqlReportQueries';
import simoDevices, * as fromSimoDevices from './simoDevices';
import quickSubs, * as fromQuickSubs from './quickSubs';
import quickPlans, * as fromQuickPlans from './quickPlans';
import quickServiceCodes, * as fromQuickServiceCodes from './quickServiceCodes';
import quickPortOuts, * as fromQuickPortOuts from './quickPortOuts';
import quickCarrierRequests, * as fromQuickCarrierRequests from './quickCarrierRequests';

const reducer = combineReducers({
  form,
  login,
  users,
  addresses,
  subs,
  csa,
  customPlans,
  plans,
  attPlans,
  serviceCodes,
  cycle,
  devices,
  deviceContracts,
  insurancePlans,
  insuranceContracts,
  insuranceDevices,
  purchases,
  leases,
  attLeases,
  credit,
  logs,
  attSubs,
  notes,
  filters,
  payments,
  preactivations,
  voiceRecords,
  shippings,
  orders,
  loginDevices,
  rollingArrangements,
  tracfonePlans,
  tracfoneSubs,
  tracfoneServiceCodes,
  resellers,
  allSubs,
  tracfoneLeases,
  simoSubs,
  simoLeases,
  simoPlans,
  simoDiagnostics,
  simoTopUps,
  sqlReports,
  sqlReportQueries,
  simoDevices,
  quickSubs,
  quickPlans,
  quickServiceCodes,
  quickPortOuts,
  quickCarrierRequests,
});

export default reducer;

export const getLoggedInUser = (state) => fromLogin.getLogin(state.login);
export const getIsLoginPendingStatus = (state) =>
  fromLogin.getIsLoginPendingStatus(state.login);
export const getIsLoggedIn = (state) => fromLogin.getIsLoggedIn(state.login);
export const getIsAdmin = (state) => fromLogin.getIsAdmin(state.login);
export const getIsResellerGroup = (state) =>
  fromLogin.getIsResellerGroup(state.login);
export const getIsAdminOrManager = (state) =>
  fromLogin.getIsAdminOrManager(state.login);
export const getIncludedInGroups = (state, groups = []) =>
  fromLogin.getIncludedInGroups(state.login, groups);

export const getAllUsers = (state, page = 1, childAccounts, userId) =>
  fromUsers.getAllUsers(state.users, page, childAccounts, userId);
export const getAllUsersWithoutPagination = (state) =>
  fromUsers.getAllUsersWithoutPagination(state.users);
export const getSearchUsers = (state, page = 1) =>
  fromUsers.getSearchUsers(state.users, page);
export const getUser = (state, userId) =>
  fromUsers.getUser(state.users, userId);
export const getUserNotFound = (state, userId) =>
  fromUsers.getUserNotFound(state.users, userId);
export const getSaveUserStatus = (state, userId) =>
  fromUsers.getSaveUserStatus(state.users, userId);
export const getCreateUserStatus = (state) =>
  fromUsers.getCreateUserStatus(state.users);
export const getNewUserId = (state) => fromUsers.getNewUserId(state.users);

export const getUserIsActiveErrorMessage = (state, userId) =>
  fromUsers.getUserIsActiveErrorMessage(state.users, userId);

export const getUserLogs = (state, page = 1) =>
  fromLogs.getUserLogs(state.logs, page);

export const getLoginDevices = (state, page = 1) =>
  fromLoginDevices.getLoginDevices(state.loginDevices, page);

export const getNotes = (state, page = 1) =>
  fromNotes.getNotes(state.notes, page);

export const getPaymentMethodSucceeded = (state) =>
  fromForm.getPaymentMethodSucceeded(state.form);
export const getEcheckPaymentMethodSucceeded = (state) =>
  fromForm.getEcheckPaymentMethodSucceeded(state.form);
export const getNoteSubmitSucceeded = (state) =>
  fromForm.getNoteSubmitSucceeded(state.form);
export const getNewUserSubmitSucceeded = (state) =>
  fromForm.getNewUserSubmitSucceeded(state.form);
export const getNewUserEmailStatus = (state) =>
  fromForm.getNewUserEmailStatus(state.form);
export const getNewUserPhoneStatus = (state) =>
  fromForm.getNewUserPhoneStatus(state.form);
export const getAddressSubmitSucceeded = (state) =>
  fromForm.getAddressSubmitSucceeded(state.form);
export const getNewSubSubmitSucceeded = (state) =>
  fromForm.getNewSubSubmitSucceeded(state.form);
export const getSubmitStatus = (state, formName) =>
  fromForm.getSubmitStatus(state, formName);
export const getValidatePortValue = fromForm.getValidatePortValue;
export const getValidateDeviceValue = fromForm.getValidateDeviceValue;
export const getSubmitSucceeded = (state, formName) =>
  fromForm.getSubmitSucceeded(state, formName);
export const getSaveAddressStatus = (state) =>
  fromAddresses.getSaveAddressStatus(state.addresses);
export const getCreateAddressStatus = (state) =>
  fromAddresses.getCreateAddressStatus(state.addresses);

export const getUserPaymentMethods = (state, page = 1) =>
  fromPayments.getUserPaymentMethods(state.payments, page);

export const getUserPurchases = (state, page = 1) =>
  fromPurchases.getUserPurchases(state.purchases, page);
export const getUserCancelledPurchases = (state, page = 1) =>
  fromPurchases.getUserCancelledPurchases(state.purchases, page);
export const getUserCancelledPurchasesStatus = (state, page = 1) =>
  fromPurchases.getUserCancelledPurchasesStatus(state.purchases, page);
export const getBlankInvoice = (state) =>
  fromPurchases.getBlankInvoice(state.purchases);
export const getSpecificUserPurchases = (state, page = 1) =>
  fromPurchases.getSpecificUserPurchases(state.purchases, page);
export const getOverduePurchases = (state) =>
  fromPurchases.getOverduePurchases(state.purchases);
export const getPurchaseContractsByUserId = (state, purchaseId) =>
  fromPurchases.getPurchaseContractsByUserId(state, purchaseId);
export const getPurchase = (state, purchaseId) =>
  fromPurchases.getPurchase(state.purchases, purchaseId);
export const getPurchaseLineItems = (state, purchaseId, page) =>
  fromPurchases.getPurchaseLineItems(state.purchases, purchaseId, page);
export const getPurchaseLineItemsCount = (state, purchaseId) =>
  fromPurchases.getPurchaseLineItemsCount(state.purchases, purchaseId);
export const getPurchaseNotFound = (state, purchaseId) =>
  fromPurchases.getPurchaseNotFound(state.purchases, purchaseId);
export const getCreateBuyoutPurchaseFullErrorMessage = (state) =>
  fromPurchases.getCreateBuyoutPurchaseFullErrorMessage(state.purchases);
export const getPartialRefundErrorMessage = (state) =>
  fromPurchases.getPartialRefundErrorMessage(state.purchases);
export const getCreateBuyoutPurchaseId = (state) =>
  fromPurchases.getCreateBuyoutPurchaseId(state.purchases);
export const getCreateBuyoutPurchaseStatus = (state) =>
  fromPurchases.getCreateBuyoutPurchaseStatus(state.purchases);
export const getBuyoutPurchaseValue = fromForm.getBuyoutPurchaseValue;
export const getSearchPurchases = (state, page = 1) =>
  fromPurchases.getSearchPurchases(state.purchases, page);
export const getPendingArrangement = (state, page = 1) =>
  fromPurchases.getPendingArrangement(state.purchases, page);
export const getRefundAffirmErrorMessage = (state) =>
  fromPurchases.getRefundAffirmErrorMessage(state.purchases);

export const getUpgradePurchaseId = (state) =>
  fromPurchases.getUpgradePurchaseId(state.purchases);
export const getAttUpgradePurchaseId = (state) =>
  fromPurchases.getAttUpgradePurchaseId(state.purchases);
export const getSimoUpgradePurchaseId = (state) =>
  fromPurchases.getSimoUpgradePurchaseId(state.purchases);
export const getTracfoneUpdatePlanInvoice = (state) =>
  fromPurchases.getTracfoneUpdatePlanInvoice(state.purchases);
export const getQuickUpgradePurchaseId = (state) =>
  fromPurchases.getQuickUpgradePurchaseId(state.purchases);
export const getSimoTopUpUpgradePurchaseId = (state) =>
  fromPurchases.getSimoTopUpUpgradePurchaseId(state.purchases);

export const getAllAttSubs = (state, page = 1) =>
  fromAttSubs.getAllAttSubs(state.attSubs, page);
export const getAllUserAttSubs = (state, userId) =>
  fromAttSubs.getAllUserAttSubs(state.attSubs, userId);
export const getAllTracfoneSubs = (state, page = 1) =>
  fromTracfoneSubs.getAllTracfoneSubs(state.tracfoneSubs, page);
export const getAllSimoSubs = (state, page = 1) =>
  fromSimoSubs.getAllSimoSubs(state.simoSubs, page);
export const getAllUserSimoSubs = (state, page = 1) =>
  fromSimoSubs.getAllUserSimoSubs(state.simoSubs, page);
export const getAllUserTracfoneSubs = (state, userId) =>
  fromTracfoneSubs.getAllUserTracfoneSubs(state.tracfoneSubs, userId);
export const getAttSub = (state, id) =>
  fromAttSubs.getAttSub(state.attSubs, id);
export const getTracfoneSub = (state, id) =>
  fromTracfoneSubs.getTracfoneSub(state.tracfoneSubs, id);
export const getSimoSub = (state, id) =>
  fromSimoSubs.getSimoSub(state.simoSubs, id);
export const getSimoSubNotFoundFromFind = (state) =>
  fromSimoSubs.getSimoSubNotFoundFromFind(state.simoSubs);
export const getAttSubNotFound = (state, id) =>
  fromAttSubs.getAttSubNotFound(state.attSubs, id);
export const getTracfoneSubNotFound = (state, id) =>
  fromTracfoneSubs.getTracfoneSubNotFound(state.tracfoneSubs, id);
export const getUserAttSubs = (state, page = 1) =>
  fromAttSubs.getUserAttSubs(state.attSubs, page);
export const getUserTracfoneSubs = (state, page = 1) =>
  fromTracfoneSubs.getUserTracfoneSubs(state.tracfoneSubs, page);
export const getUserSimoSubs = (state, page = 1) =>
  fromSimoSubs.getUserSimoSubs(state.simoSubs, page);
export const getAttSubNotFoundFromFind = (state) =>
  fromAttSubs.getAttSubNotFoundFromFind(state.attSubs);
export const getAllAttSubsCount = (state, page = 1) =>
  fromAttSubs.getAllAttSubsCount(state.attSubs, page);
export const getAllTracfoneSubsCount = (state, page = 1) =>
  fromTracfoneSubs.getAllTracfoneSubsCount(state.tracfoneSubs, page);
export const getTracfoneSubNotFoundFromFind = (state, page = 1) =>
  fromTracfoneSubs.getTracfoneSubNotFoundFromFind(state.tracfoneSubs, page);
export const getSearchAttSubs = (state, page = 1) =>
  fromAttSubs.getSearchAttSubs(state.attSubs, page);
export const getSearchTracfoneSubs = (state, page = 1) =>
  fromTracfoneSubs.getSearchTracfoneSubs(state.tracfoneSubs, page);
export const getSearchSimoSubs = (state, page = 1) =>
  fromSimoSubs.getSearchSimoSubs(state.simoSubs, page);
export const getFilteredAttSubs = (state, filter, page = 1) =>
  fromAttSubs.getFilteredAttSubs(state.attSubs, filter, page);
export const getFilteredSimoSubs = (state, filter, page = 1) =>
  fromSimoSubs.getFilteredSimoSubs(state.simoSubs, filter, page);
export const getFilteredSprintSubs = (state, filter, page = 1) =>
  fromSubs.getFilteredSprintSubs(state.subs, filter, page);
export const getFilteredTracfoneSubs = (state, filter, page = 1) =>
  fromTracfoneSubs.getFilteredTracfoneSubs(state.tracfoneSubs, filter, page);

export const getAllSubs = (state, page = 1) =>
  fromSubs.getAllSubs(state.subs, page);
export const getAllUserSprintSubs = (state, userId) =>
  fromSubs.getAllUserSubs(state.subs, userId);
export const getSearchSubs = (state, page = 1) =>
  fromSubs.getSearchSubs(state.subs, page);
export const getUserSubs = (state, page = 1) =>
  fromSubs.getUserSubs(state.subs, page);
export const getAllSubsCount = (state, page = 1) =>
  fromSubs.getAllSubsCount(state.subs, page);
export const getCreatedAttSub = (state) =>
  fromAttSubs.getCreatedAttSub(state.attSubs);
export const getCreatedTracfoneSub = (state) =>
  fromTracfoneSubs.getCreatedTracfoneSub(state.tracfoneSubs);
export const getCreatedSimoSub = (state) =>
  fromSimoSubs.getCreatedSimoSub(state.simoSubs);
export const getSub = (state, id) => fromSubs.getSub(state.subs, id);
export const getPortMessage = (state, id) =>
  fromSubs.getPortMessage(state.subs, id);
export const getPortMessageArray = (state, id) =>
  fromSubs.getPortMessageArray(state.subs, id);
export const getSubNotFound = (state, id) =>
  fromSubs.getSubNotFound(state.subs, id);
export const getSubNotFoundFromFind = (state) =>
  fromSubs.getSubNotFoundFromFind(state.subs);

export const getSubLeases = (state, page = 1) =>
  fromLeases.getSubLeases(state.leases, page);
export const getOutstandingLeases = (state) =>
  fromLeases.getOutstandingLeases(state.leases);
export const getLease = (state, leaseId) =>
  fromLeases.getLease(state.leases, leaseId);
export const getLeases = (state) => fromLeases.getLeases(state.leases);
export const getUserLeases = (state, userId) =>
  fromLeases.getUserLeases(state.leases, userId);
export const getLeaseNotFound = (state, leaseId) =>
  fromLeases.getLeaseNotFound(state.leases, leaseId);

export const getAttSubLeases = (state, page = 1) =>
  fromAttLeases.getSubLeases(state.attLeases, page);
export const getAttOutstandingLeases = (state) =>
  fromAttLeases.getAttOutstandingLeases(state.attLeases);

export const getTracfoneSubLeases = (state, page = 1) =>
  fromTracfoneLeases.getSubLeases(state.tracfoneLeases, page);

export const getSimoSubLeases = (state, page = 1) =>
  fromSimoLeases.getSubLeases(state.simoLeases, page);

export const getUserCredits = (state, page = 1) =>
  fromCredit.getUserCredit(state.credit, page);
export const getCreditNotFound = (state, creditId) =>
  fromCredit.getCreditNotFound(state.credit, creditId);
export const getCredit = (state, id) => fromCredit.getCredit(state.credit, id);

export const getPreactivation = (state, id) =>
  fromPreactivations.getPreactivation(state.preactivations, id);
export const getUserPreactivations = (state, userId) =>
  fromPreactivations.getUserPreactivations(state.preactivations, userId);

export const getSetCsaStatus = (state) => fromSubs.getSetCsaStatus(state.subs);
export const getUpdateDeviceStatus = (state) =>
  fromSubs.getUpdateDeviceStatus(state.subs);
export const getDeviceDetails = (state) =>
  fromSubs.getDeviceDetails(state.subs);
export const getAttDeviceDetails = (state) =>
  fromAttSubs.getAttDeviceDetails(state.attSubs);
export const getTracfoneDeviceDetails = (state) =>
  fromTracfoneSubs.getTracfoneDeviceDetails(state.tracfoneSubs);
export const getSimoDeviceDetails = (state) =>
  fromSimoSubs.getSimoDeviceDetails(state.simoSubs);
export const getUpdatePlanStatus = (state) =>
  fromSubs.getUpdatePlanStatus(state.subs);
export const getPortResponse = (state, subId) =>
  fromSubs.getPortResponse(state.subs, subId);
export const getTracfonePortResponse = (state, subId) =>
  fromTracfoneSubs.getTracfonePortResponse(state.tracfoneSubs, subId);
export const getPortModifyResponse = (state, subId) =>
  fromSubs.getPortModifyResponse(state.subs, subId);
export const getActivationResponse = (state, subId) =>
  fromSubs.getActivationResponse(state.subs, subId);
export const getAttActivationResponse = (state, subId) =>
  fromAttSubs.getAttActivationResponse(state.attSubs, subId);
export const getTracfoneActivationResponse = (state, subId) =>
  fromTracfoneSubs.getTracfoneActivationResponse(state.tracfoneSubs, subId);
export const getSimoActivationResponse = (state, subId) =>
  fromSimoSubs.getSimoActivationResponse(state.simoSubs, subId);
export const getTracfonePortStatusResponse = (state, subId) =>
  fromTracfoneSubs.getTracfonePortStatusResponse(state.tracfoneSubs, subId);
export const getUpdateStatusResponse = (state, subId) =>
  fromSubs.getUpdateStatusResponse(state.subs, subId);
export const getTracfoneUpdateStatusResponse = (state, subId) =>
  fromTracfoneSubs.getTracfoneUpdateStatusResponse(state.tracfoneSubs, subId);
export const getPortInfo = (state, subId) =>
  fromSubs.getPortInfo(state.subs, subId);
export const getTracfonePortInfo = (state, subId) =>
  fromTracfoneSubs.getTracfonePortInfo(state.tracfoneSubs, subId);
export const getAllPortInfo = (state, subId) =>
  fromSubs.getAllPortInfo(state.subs, subId);
export const getSubDataUsage = (state, subId) =>
  fromSubs.getSubDataUsage(state.subs, subId);
export const getSubVoiceUsage = (state, subId) =>
  fromSubs.getSubVoiceUsage(state.subs, subId);
export const getSubRoamingUsage = (state, subId) =>
  fromSubs.getSubRoamingUsage(state.subs, subId);
export const getSubDailyUsage = (state, subId) =>
  fromSubs.getSubDailyUsage(state.subs, subId);

export const getSubUpcomingPlan = (state, subId) =>
  fromSubs.getSubUpcomingPlan(state.subs, subId);
export const getAttSubUpcomingPlan = (state, subId) =>
  fromSubs.getSubUpcomingPlan(state.attSubs, subId);
export const getSimoSubUpcomingPlan = (state, subId) =>
  fromSimoSubs.getSubUpcomingPlan(state.simoSubs, subId);

export const getTracfoneSubDataUsage = (state, subId) =>
  fromTracfoneSubs.getTracfoneSubDataUsage(state.tracfoneSubs, subId);

export const getLastCsa = (state) => fromCsa.getLastCsa(state.csa);

export const getPlan = (state, id) => fromPlans.getPlan(state.plans, id);
export const getAttPlan = (state, id) =>
  fromAttPlans.getAttPlan(state.attPlans, id);
export const getTracfonePlan = (state, id) =>
  fromTracfonePlans.getTracfonePlan(state.tracfonePlans, id);

export const getAllPlans = (state) => fromPlans.getAllPlans(state.plans);
export const getAllAttPlans = (state) =>
  fromAttPlans.getAllAttPlans(state.attPlans);
export const getAllTracfonePlans = (state) =>
  fromTracfonePlans.getAllTracfonePlans(state.tracfonePlans);
export const getAllSimoPlans = (state) =>
  fromSimoPlans.getAllSimoPlans(state.simoPlans);

export const getAllServiceCodes = (state) =>
  fromServiceCodes.getAllServiceCodes(state.serviceCodes);
export const getServiceCodesById = (state) =>
  fromServiceCodes.getServiceCodesById(state.serviceCodes);

export const getAllTracfoneServiceCodes = (state) =>
  fromTracfoneServiceCodes.getAllTracfoneServiceCodes(
    state.tracfoneServiceCodes,
  );
export const getTracfoneServiceCodesById = (state) =>
  fromTracfoneServiceCodes.getTracfoneServiceCodesById(
    state.tracfoneServiceCodes,
  );

export const getSubServiceCodesError = (state, subId) =>
  fromSubs.getSubServiceCodesError(state.subs, subId);

export const getTracfoneSubServiceCodes = (state, subId) =>
  fromTracfoneSubs.getTracfoneSubServiceCodes(state.tracfoneSubs, subId);
export const getTracfoneSubServiceCodesError = (state, subId) =>
  fromTracfoneSubs.getTracfoneSubServiceCodesError(state.tracfoneSubs, subId);

export const getTracfoneSubDetailsInfo = (state, subId) =>
  fromTracfoneSubs.getTracfoneSubDetailsInfo(state.tracfoneSubs, subId);

export const getAllDevices = (state) =>
  fromDevices.getAllDevices(state.devices);
export const getDeviceSpecs = (state, sku) =>
  fromDevices.getDevice(state.devices, sku);

export const getContracts = (state) =>
  fromInsuranceContracts.getContracts(state.insuranceContracts);
export const getContract = (state, id) =>
  fromInsuranceContracts.getContract(state.insuranceContracts, id);
export const getSubContracts = (state, subId, carrier) =>
  fromInsuranceContracts.getSubContracts(
    state.insuranceContracts,
    subId,
    carrier,
  );
export const getCreatedContractStatus = (state) =>
  fromInsuranceContracts.getCreatedContractStatus(state.insuranceContracts);
export const getCreatedContract = (state) =>
  fromInsuranceContracts.getCreatedContract(state.insuranceContracts);
export const getAllInsuranceContracts = (
  state,
  page = 1,
  att_subscription,
  user_profile,
) =>
  fromInsuranceContracts.getAllInsuranceContracts(
    state.insuranceContracts,
    page,
    att_subscription,
    user_profile,
  );

export const getInsurancePlan = (state, id) =>
  fromInsurancePlans.getInsurancePlan(state.insurancePlans, id);

export const getDevices = (state) =>
  fromInsuranceDevices.getDevices(state.insuranceDevices);
export const getDevice = (state, id) =>
  fromInsuranceDevices.getDevice(state.insuranceDevices, id);
export const getDevicesByContract = (state, contractId) =>
  fromInsuranceDevices.getDevicesByContract(state.insuranceDevices, contractId);
export const getCreatedDeviceStatus = (state) =>
  fromInsuranceDevices.getCreatedDeviceStatus(state.insuranceDevices);
export const getCreatedDevice = (state) =>
  fromInsuranceDevices.getCreatedDevice(state.insuranceDevices);

export const getPageCount = (state, resourceType, requestKey, page = 1) => {
  state = state[resourceType];
  requestKey += page;

  if (!state.requests || !state.requests[requestKey]) return 0;
  const { count, next, perPage } = state.requests[requestKey];
  if (!next) return page;
  if (perPage === 0) return 0;

  let pageCount = Math.floor(count / perPage);
  if (pageCount !== count / perPage) {
    pageCount += 1;
  }

  return pageCount;
};

export const getCycle = (state) => fromCycle.getCycle(state.cycle);

export const getFilters = (state) => fromfilters.getFilters(state.filters);

export const getSprintCallRecordsError = (state, subId) =>
  fromVoiceRecords.getSprintCallRecordsError(state.voiceRecords, subId);
export const getSprintCallRecordsSucceed = (state, subId) =>
  fromVoiceRecords.getSprintCallRecordsSucceed(state.voiceRecords, subId);

export const getUserDeviceContracts = (state, userId) =>
  fromDeviceContracts.getUserDeviceContracts(state.deviceContracts, userId);
export const getDeviceContract = (state, deviceContractId) =>
  fromDeviceContracts.getDeviceContract(
    state.deviceContracts,
    deviceContractId,
  );

export const getRollingArrangement = (state, rollingArrangementId) =>
  fromRollingArrangements.getRollingArrangement(
    state.rollingArrangements,
    rollingArrangementId,
  );
export const getRollingArrangements = (state, page = 1) =>
  fromRollingArrangements.getRollingArrangements(
    state.rollingArrangements,
    page,
  );
export const getUserRollingArrangements = (state, page = 1) =>
  fromRollingArrangements.getUserRollingArrangements(
    state.rollingArrangements,
    page,
  );

// Shippings
export const getShippingPrice = (state) =>
  fromShippings.getShippingPrice(state.shippings);
export const getShippingPriceStatus = (state) =>
  fromShippings.getShippingPriceStatus(state.shippings);
export const getShippingPriceError = (state) =>
  fromShippings.getShippingPriceError(state.shippings);

export const getOrders = (state, page = 1) =>
  fromOrders.getOrders(state.orders, page);
export const getOrderById = (state, id) =>
  fromOrders.getOrderById(state.orders, id);
export const getPurchaseOrders = (state, purchaseId) =>
  fromOrders.getPurchaseOrders(state.orders, purchaseId);

// All subs
export const getAllUserSubs = (state, userId) =>
  fromAllSubs.getAllUserSubs(state.allSubs, userId);
export const getAllCarriersSubsWithoutLayover = (state, page = 1) =>
  fromAllSubs.getAllCarriersSubsWithoutLayover(state.allSubs, page);
export const getAllCarriersSubsWithoutLayoverPageCount = (state) =>
  fromAllSubs.getAllCarriersSubsWithoutLayoverPageCount(state.allSubs);

export const getAttFilteredSubs = (state, requestKey, page) =>
  fromAttSubs.getAttFilteredSubs(state.attSubs, requestKey, page);
export const getAttFilteredSubsCount = (state, requestKey) =>
  fromAttSubs.getAttFilteredSubsCount(state.attSubs, requestKey);
export const getFilteredSubs = (state, requestKey, page) =>
  fromSubs.getFilteredSubs(state.subs, requestKey, page);
export const getFilteredSubsCount = (state, requestKey) =>
  fromSubs.getFilteredSubsCount(state.subs, requestKey);

export const getCustomPlanPricing = (state, id) =>
  fromCustomPlans.getCustomPlanPricing(state.customPlans, id);
export const getCustomPlanPricingList = (state, page = 1) =>
  fromCustomPlans.getCustomPlanPricingList(state.customPlans, page);
export const getUserCustomPlans = (state) =>
  fromCustomPlans.getUserCustomPlans(state.customPlans);
export const getUserCustomPlansStatusPending = (state) =>
  fromCustomPlans.getUserCustomPlansStatusPending(state.customPlans);
export const updateCustomPlanPricingStatusPending = (state) =>
  fromCustomPlans.updateCustomPlanPricingStatusPending(state.customPlans);
export const createCustomPlanPricingStatusPending = (state) =>
  fromCustomPlans.createCustomPlanPricingStatusPending(state.customPlans);
export const deleteCustomPlanPricingStatusPending = (state) =>
  fromCustomPlans.deleteCustomPlanPricingStatusPending(state.customPlans);

export const getTracfoneFilteredSubs = (state, requestKey, page) =>
  fromTracfoneSubs.getTracfoneFilteredSubs(
    state.tracfoneSubs,
    requestKey,
    page,
  );
export const getTracfoneFilteredSubsCount = (state, requestKey) =>
  fromTracfoneSubs.getTracfoneFilteredSubsCount(state.tracfoneSubs, requestKey);

export const getAllInitialsSubs = (state) =>
  fromSubs.getAllInitialsSubs(state.subs);
export const getAllAttInitialsSubs = (state) =>
  fromAttSubs.getAllAttInitialsSubs(state.attSubs);
export const getAllTracfoneInitialsSubs = (state) =>
  fromTracfoneSubs.getAllTracfoneInitialsSubs(state.tracfoneSubs);
export const getAllSimoInitialsSubs = (state) =>
  fromSimoSubs.getAllSimoInitialsSubs(state.simoSubs);
export const getAllInitialsSubsStatus = (state) =>
  fromSubs.getAllInitialsSubsStatus(state.subs);
export const getAllAttInitialsSubsStatus = (state) =>
  fromAttSubs.getAllAttInitialsSubsStatus(state.attSubs);
export const getAllTracfoneInitialsSubsStatus = (state) =>
  fromTracfoneSubs.getAllTracfoneInitialsSubsStatus(state.tracfoneSubs);
export const getAllSimoInitialsSubsStatus = (state) =>
  fromSimoSubs.getAllSimoInitialsSubsStatus(state.simoSubs);

export const getAllSimoTopUps = (state, subId) =>
  fromSimoTopUps.getAllSimoTopUps(state.simoTopUps, subId);

//  sql reports
export const getSqlReports = (state, page) =>
  fromSqlReports.getSqlReports(state.sqlReports, page);
export const getSqlReport = (state, id) =>
  fromSqlReports.getSqlReport(state.sqlReports, id);

//  sql report queries
export const getSqlReportQuery = (state, id) =>
  fromSqlReportQueries.getSqlReportQuery(state.sqlReportQueries, id);

// simo devices
export const getAllSimoDevices = (state, page) =>
  fromSimoDevices.getAllSimoDevices(state.simoDevices, page);
export const getSearchSimoDevices = (state, page) =>
  fromSimoDevices.getSearchSimoDevices(state.simoDevices, page);
export const getSimoDevice = (state, id) =>
  fromSimoDevices.getSimoDevice(state.simoDevices, id);
export const getUserSimoDevices = (state, userId, page) =>
  fromSimoDevices.getUserSimoDevices(state.simoDevices, userId, page);
export const getSimoDeviceDiagnostics = (state, deviceId) =>
  fromSimoDiagnostics.getSimoDeviceDiagnostics(state.simoDiagnostics, deviceId);

// quick subs
export const getQuickSub = (state, id) =>
  fromQuickSubs.getQuickSub(state.quickSubs, id);
export const getQuickSubNotFoundFromFind = (state) =>
  fromQuickSubs.getQuickSubNotFoundFromFind(state.quickSubs);
export const getCreatedQuickSub = (state) =>
  fromQuickSubs.getCreatedQuickSub(state.quickSubs);
export const getAllQuickSubs = (state, page = 1) =>
  fromQuickSubs.getAllQuickSubs(state.quickSubs, page);
export const getAllQuickInitialsSubs = (state) =>
  fromQuickSubs.getAllQuickInitialsSubs(state.quickSubs);
export const getAllQuickInitialsSubsStatus = (state) =>
  fromQuickSubs.getAllQuickInitialsSubsStatus(state.quickSubs);
export const getSearchQuickSubs = (state, page = 1) =>
  fromQuickSubs.getSearchQuickSubs(state.quickSubs, page);
export const getFilteredQuickSubs = (state, filter, page = 1) =>
  fromQuickSubs.getFilteredQuickSubs(state.quickSubs, filter, page);
export const getQuickPortResponse = (state, subId) =>
  fromQuickSubs.getQuickPortResponse(state.quickSubs, subId);
export const getQuickSubUpcomingPlan = (state, subId) =>
  fromQuickSubs.getQuickSubUpcomingPlan(state.quickSubs, subId);
export const getQuickSubServiceCodes = (state, subId) =>
  fromQuickSubs.getQuickSubServiceCodes(state.quickSubs, subId);
export const getQuickSubRunningActions = (state, subId) =>
  fromQuickSubs.getQuickSubRunningActions(state.quickSubs, subId);
export const getQuickPortData = (state, subId) =>
  fromQuickSubs.getQuickPortData(state.quickSubs, subId);
export const getQuickMdnHistory = (state, subId) =>
  fromQuickSubs.getQuickMdnHistory(state.quickSubs, subId);
export const getQuickSyncStatusResponse = (state, subId) =>
  fromQuickSubs.getQuickSyncStatusResponse(state.quickSubs, subId);

// quick plans
export const getAllQuickPlans = (state) =>
  fromQuickPlans.getAllQuickPlans(state.quickPlans);

// quick service codes
export const getAllQuickServiceCodes = (state) =>
  fromQuickServiceCodes.getAllQuickServiceCodes(state.quickServiceCodes);
export const getQuickVendorServiceCodes = (state, vendor) =>
  fromQuickServiceCodes.getAllQuickServiceCodes(
    state.quickServiceCodes,
    vendor,
  );

// quick port outs
export const getQuickPortOuts = (state, page = 1) =>
  fromQuickPortOuts.getQuickPortOuts(state.quickPortOuts, page);

// quick carrier requests
export const getQuickCarrierRequests = (state, subId, page = 1) =>
  fromQuickCarrierRequests.getQuickCarrierRequests(
    state.quickCarrierRequests,
    subId,
    page,
  );

// new child user
export const getNewChildUserSubmitSucceeded = (state) =>
  fromForm.getNewChildUserSubmitSucceeded(state.form);
export const getNewChildUserPhoneStatus = (state) =>
  fromForm.getNewChildUserPhoneStatus(state.form);
